import QueueTaskEmployeeItem from '../../../../../projects/groups/i-service/model/queue-tasks/QueueTaskEmployeeItem';
import QueueTaskPriorityItem from '../../../../../projects/groups/i-service/model/queue-tasks/QueueTaskPriorityItem';
import QueueTaskStatusItem from '../../../../../projects/groups/i-service/model/queue-tasks/QueueTaskStatusItem';

/**
 * * Модель запроса на создание очереди задач
 */
export default class ProjectQueueTaskCreateRequest  {
	/**
	 * * Номер группы
	 */
	GroupId?: number;
	/**
	 * * Номер рабочего пространства
	 */
	NamespaceId?: string;
	/**
	 * * Нахвание
	 */
	Name!: string;
	/**
	 * * Список сотрудников
	 */
	Employees!: Array<QueueTaskEmployeeItem>;
	/**
	 * * Список приоритетов
	 */
	Priorities!: Array<QueueTaskPriorityItem>;
	/**
	 * * Список статусов
	 */
	Statuses!: Array<QueueTaskStatusItem>;
	constructor(obj?: Partial<ProjectQueueTaskCreateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
